export default __webpack_public_path__ + "static/media/about-bg3.cd7c998d.png";